import { TransactionUpdateReadRequest } from "../models/Request/transactionUpdateReadRequest";
import { TransactionUpdateStatusResponse } from "../models/Response/transactionUpdateStatusResponse";
import { UnifiedResponse } from "../models/Response/unifiedResponse";
import apiClient from "./apiClient";

export const mainLayoutApi = {
  fetchTransactionUpdate: async (): Promise<UnifiedResponse<TransactionUpdateStatusResponse>> => {
    const response = await apiClient.post<UnifiedResponse<TransactionUpdateStatusResponse>>(
      "admin_payment/transaction_update_status/retrieve/list"
    );
    return response.data;
  },

  transactionUpdateReadStatus: async (request: TransactionUpdateReadRequest): Promise<UnifiedResponse<any | null>> => {
    const response = await apiClient.post<UnifiedResponse<any | null>>(
      "admin_payment/transaction_request_update/read_status", request
    );
    return response.data;
  }
};